import React, { useState } from "react";
import { Image, Collapse } from "react-bootstrap";
import "../QuizLandingPage/QuizLandingPage.style.scss";
import {
  starIconOrange,
  iconPlus,
  iconMinus,
} from "../../lib/images";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";

const OFFICES = [
  {
    id: "us_senator",
    titleKey: "office_us_senator",
    descKey: "office_us_senator_desc",
  },
  {
    id: "congressperson",
    titleKey: "office_congressperson",
    descKey: "office_congressperson_desc",
  },
  {
    id: "governor",
    titleKey: "office_governor",
    descKey: "office_governor_desc",
  },
  {
    id: "lieutenant_governor",
    titleKey: "office_lieutenant_governor",
    descKey: "office_lieutenant_governor_desc",
  },
  {
    id: "secretary_of_state",
    titleKey: "office_secretary_of_state",
    descKey: "office_secretary_of_state_desc",
  },
  {
    id: "attorney_general",
    titleKey: "office_attorney_general",
    descKey: "office_attorney_general_desc",
  },
  {
    id: "commissioner_of_agriculture",
    titleKey: "office_commissioner_of_agriculture",
    descKey: "office_commissioner_of_agriculture_desc",
  },
  {
    id: "commissioner_of_insurance_and_fire_safety",
    titleKey: "office_commissioner_of_insurance_and_fire_safety",
    descKey: "office_commissioner_of_insurance_and_fire_safety_desc",
  },
  {
    id: "commissioner_of_labor",
    titleKey: "office_commissioner_of_labor",
    descKey: "office_commissioner_of_labor_desc",
  },
  {
    id: "state_school_superintendent",
    titleKey: "office_state_school_superintendent",
    descKey: "office_state_school_superintendent_desc",
  },
  {
    id: "public_service_commissioner",
    titleKey: "office_public_service_commissioner",
    descKey: "office_public_service_commissioner_desc",
  },
  {
    id: "state_senator",
    titleKey: "office_state_senator",
    descKey: "office_state_senator_desc",
  },
  {
    id: "state_house_representative",
    titleKey: "office_state_house_representative",
    descKey: "office_state_house_representative_desc",
  },
  {
    id: "county_commissioner",
    titleKey: "office_county_commissioner",
    descKey: "office_county_commissioner_desc",
  },
  {
    id: "mayor",
    titleKey: "office_mayor",
    descKey: "office_mayor_desc",
  },
  {
    id: "mayor_pro_tem",
    titleKey: "office_mayor_pro_tem",
    descKey: "office_mayor_pro_tem_desc",
  },
  {
    id: "boe",
    titleKey: "office_boe",
    descKey: "office_boe_desc",
  },
  {
    id: "city_council",
    titleKey: "office_city_council",
    descKey: "office_city_council_desc",
  },
  {
    id: "at_large",
    titleKey: "office_at_large",
    descKey: "office_at_large_desc",
  },
];

function OfficeDescription() {
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const [openState, setOpenState] = useState(() =>
    OFFICES.reduce((acc, office) => {
      acc[office.id] = !isMobile;
      return acc;
    }, {})
  );

  function goToAnchor(anchor) {
    var loc = document.location.toString().split("#")[0];
    document.location = loc + "#" + anchor;
    return false;
  }

  const handleButtonClick = (id) => {
    setOpenState((prev) => ({
      ...prev,
      [id]: true,
    }));
    goToAnchor(id);
    return false;
  };

  const toggleOpen = (id) => {
    setOpenState((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div className="ctn-quiz-lp03 office-description">
      <div className="quiz-lp-top-header">
        <Image src={starIconOrange} className="icon-star-left" alt="" />
        <div className="top-header-title">
          <p>{t("learn_more_offices")}</p>
        </div>
        <Image src={starIconOrange} className="icon-star-right" alt="" />
      </div>
      <div className="quiz-lp-btn-action">
        {OFFICES.map((office) => (
          <button
            key={office.id}
            type="button"
            className="btn-action-item"
            onClick={() => handleButtonClick(office.id)}
          >
            {t(office.titleKey)}
          </button>
        ))}
      </div>
      {OFFICES.map((office, index) => {
        const isOpen = Boolean(openState[office.id]);
        const collapseId = `collapse-text-${String(index + 1).padStart(2, "0")}`;
        return (
          <div className="collape-item" key={office.id}>
            <div className="collape-item-top" id={office.id}>
              <div className="collape-item-lable">{t(office.titleKey)}</div>
              <button
                type="button"
                className="collape-item-button"
                onClick={() => toggleOpen(office.id)}
                aria-controls={collapseId}
                aria-expanded={isOpen}
              >
                {isOpen ? (
                  <Image src={iconMinus} className="icon-minus" />
                ) : (
                  <Image src={iconPlus} />
                )}
              </button>
            </div>
            <Collapse in={isOpen}>
              <div id={collapseId} className="collapse-text-content">
                <div className="collapse-text-item">
                  <div className="col-left">
                    <div className="text-content">{t(office.descKey)}</div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        );
      })}
    </div>
  );
}

export default OfficeDescription;
